<mobile-page-content [fullPageWidth]="true" class="page-content">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <module-content>
        <app-mobile-session-view [organization]="organization"
                                 [session]="session"
                                 [athleteUser]="athleteUser"
                                 [sessionId]="session.id!"
        >
        </app-mobile-session-view>

        <button
                mat-raised-button
                color="accent"
                [disabled]="!sessionEndEnabled"
                (click)="onFeedbackNewClicked()"
                class="large-button">
            {{ 'SessionEnd' | translate}}
        </button>
    </module-content>
</mobile-page-content>
